// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"4ff2ea7b","78":"91f50d22","145":"be48c4c5","322":"6e6e937f","338":"d9a9e888","576":"c1b099ab","753":"0fc6a8e4","775":"099010c5","849":"455fca90","990":"aef85144"}[chunkId] + ".js";
};